export const GET_PAGE_NAME = 'GET_PAGE_NAME'
export const SET_PAGE_NAME = 'SET_PAGE_NAME'

export type PageAction =
  | {
      type: typeof GET_PAGE_NAME
      payload: string
    }
  | {
      type: typeof SET_PAGE_NAME
      payload: string
    }
